<template>
  <div class="view-max-shell">
    <div class="w-view-shell">
      <!-- 面包屑 -->
      <div class="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"
            >当前位置：首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>个人中心</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!-- 左侧tab栏 -->
      <div class="user-center-content">
        <div class="tab-left-shell">
          <div
            class="tab-box"
            :class="{ 'tab-box-active': tab_code == item.code }"
            @click.stop="cut_tab(item, index)"
            v-for="(item, index) in tab_list"
            :key="index"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="content-shell">
          <MyCourse v-if="tab_code == 1"></MyCourse>
          <test v-if="tab_code == 2" />
          <!--                    订单-->
          <order-from v-if="tab_code == 3" />
          <!--                    拼团-->
          <Mass v-if="tab_code == 4"></Mass>
          <!--                    优惠劵-->
          <prefe-rential v-if="tab_code == 5" />
          <!--                    个人信息-->
          <per-sonals v-if="tab_code == 6" @refresh-info="refresh_info" />
          <!--                    培训证明-->
          <train-ing v-if="tab_code == 7" />
          <!--                    推广-->
          <promo-tion v-if="tab_code == 8" />
          <!--                    发票-->
          <Bill v-if="tab_code == 9" />
          <!--              药师课程-->
          <set-year v-if="tab_code == 10" />
          <!--                    用户协议 -->
          <privacy-view type="7" v-if="tab_code == 11" key="7"></privacy-view>
          <!--                    隐私政策 -->
          <privacy-view type="9" v-if="tab_code == 12" key="9"></privacy-view>
          <!--                    个人信息收集清单 -->
          <privacy-view type="11" v-if="tab_code == 15" key="11"></privacy-view>
          <!--                    第三方信息共享清单 -->
          <privacy-view type="12" v-if="tab_code == 16" key="12"></privacy-view>
          <!--                    注销账号 -->
          <logout-view v-if="tab_code == 13" />
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="hintShow"
      top="30vh"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      center
    >
      <div style="margin:0 auto 20px;" v-html="endHintInfo.alter_info"></div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="hintShow = false">知道了</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="complaintShow"
      top="30vh"
      width="280px"
      center
    >
      <div class='complaint-main'>
        <div class="msg" style="color: #333;">个人信息安全投诉电话</div>
        <div class="msg">0731-82229030</div>
        <div class="msg" style="color: #333;">个人信息安全投诉邮箱</div>
        <div class="msg">172227276@qq.com</div>
      </div>
      <div slot="footer">
        <el-button type="primary" style="width: 160px;" @click="complaintShow = false">关闭</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="outClearShow"
      top="30vh"
      width="30%"
      center
    >
      <header style="font-size: 20px;text-align: center;" slot="title">提示</header>
      <div
        style="font-size: 16px; width:400px;margin:0 auto 0px;line-height: 32px;text-indent: 30px;color: #000;"
      >
      请注意：撤回操作后，您将退出登录，同时清除本地存储数据。
      </div>
      <div
        style="font-size: 16px; width:400px;margin:0 auto 0px;line-height: 32px;text-indent: 30px;color: #000;"
      >
      如需继续使用湘源教育，须重新同意用户隐私政策。学习记录、习题等数据需重新登录后方可查看；部分本地数据删除后无法恢复。
      </div>
      <div slot="footer" class="notice-footer">
        <div @click="outClearShow = false">取消</div>
        <span></span>
        <div style="color: #2AA9B5;" @click="handleLogOut()">仍要撤销</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import setYear from "./components/setYear";
import MyCourse from "./components/my-course";
import Bill from "./components/bill";
import OrderFrom from "./components/order";
import PrefeRential from "./components/preferential";
import PerSonals from "./components/personals";
import TrainIng from "./components/training";
import PromoTion from "./components/promotion";
import Mass from "./components/mass";
import Test from "./components/test";
import PrivacyView from "./components/privacy.vue";
import LogoutView from "./components/logout.vue";
import NoData from "@/components/no-data.vue";
export default {
  name: "personal",
  components: {
    Bill,
    MyCourse,
    setYear,
    Test,
    OrderFrom,
    PrefeRential,
    PerSonals,
    TrainIng,
    PromoTion,
    Mass,
    NoData,
    PrivacyView,
    LogoutView
  },
  data() {
    return {
      tab_code: 1,
      tab_list: [
        {
          name: "我的课程",
          code: 1,
        },
        {
          name: "模拟练习",
          code: 2,
        },
        {
          name: "培训证书",
          code: 7,
        },
        {
          name: "订单管理",
          code: 3,
        },
        {
          name: "发票管理",
          code: 9,
        },
        {
          name: "我的拼团",
          code: 4,
        },
        {
          name: "优惠券",
          code: 5,
        },
        {
          name: "个人资料",
          code: 6,
        },
        {
          name: "用户协议",
          code: 11,
        },
        {
          name: "隐私政策",
          code: 12,
        },
        {
          name: "撤回同意隐私政策",
          code: 14,
        },
        {
          name: "个人信息收集清单",
          code: 15,
        },
        {
          name: "第三方信息共享清单",
          code: 16,
        },
        {
          name: "个人信息安全投诉",
          code: 17,
        },
        {
          name: "注销账号",
          code: 13,
        },
        {
          name: "我的推广",
          code: 8,
        },
      ],
      course_list: [],
      hintShow: false,
      endHintInfo: {},
      complaintShow: false,
      outClearShow: false
    };
  },
  mounted() {
    // this.setHint()
    if (this.$route.query.code) {
      this.tab_code = this.$route.query.code;
    }
    let phar = localStorage.getItem("phar_status")
		if (phar != 0) {
      this.tab_list.splice(2, 1)
			this.tab_list.splice(0, 0, {
				name: "选择课程",
				code: 10,
			})
		}
    
    this.getHintStatus()
  },
  methods: {
    getHintStatus () {
      this.API.post("Home/course_out-study_end", {}).then(res => {
        this.endHintInfo = res.data
        // this.endHintInfo.alter_status = 1
        if (this.endHintInfo.alter_status == 1) {
          this.hintShow = true
        }
      })
    },
    setHint () {
      this.API.post('user/phar_in-buy_status', {}).then((res) => {
        if (res.errno != 0) {
          return;
        }
        this.hintShow = true
      })
    },
    refresh_info() {
      this.$emit("get-info");
    },
    cut_tab(item) {
      if (item.code == 17) {
        this.complaintShow = true;
      } else if (item.code == 14) {
        this.outClearShow = true;
      } else {
        this.tab_code = item.code;
      }
    },
    handleLogOut() {
      this.API.post("login/user_acc-login_out", {}).then((res) => {
        this.API.SMessage("登出成功");
        this.$store.state.user = "";
        this.$store.state.user_img = "";
        this.$store.state.user_info = "";
        localStorage.clear();
        window.location.href = location.protocol + "//" + location.host;
      });
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.query.code) {
        this.tab_code = this.$route.query.code;
      } else {
        this.tab_code = 1;
      }
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #2aa9b5 !important;
}

.user-center-content {
  display: flex;

  .tab-left-shell {
    width: 260px;
    min-width: 260px;
    min-height: 610px;
    background-color: #fff;

    .tab-box {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      width: 100%;
      height: 87px;
      font-size: 22px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      padding: 0 30px;
      cursor: pointer;
    }

    .tab-box-active {
      color: #2aa9b5;
      position: relative;

      &:after {
        position: absolute;
        content: "";
        left: 0px;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 40px;
        background: #2aa9b5;
      }
    }
  }

  .content-shell {
    background-color: #fff;
    min-height: 50vh;
    min-width: 960px;
    margin-left: 12px;
  }
}

/deep/ .el-progress-bar__inner {
  background-color: #2aa9b5;
}

.view-max-shell {
  width: 100%;
  min-height: 100vh;
  background-color: #f4f4f4;
}

/deep/ .el-progress-bar {
  margin: 0 0 0 20px;
  width: 260px;
}

/deep/ .el-tabs__item {
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
  font-size: 22px;
  height: 60px;
}

/deep/ .el-tabs__item.is-active {
  color: #2aa9b5;
  font-size: 22px;
}

/deep/ .el-tabs__active-bar {
  background-color: #2aa9b5;
}

/deep/ .el-breadcrumb__inner.is-link {
  font-size: 20px;
  font-weight: 400;
  color: #999;
}

/deep/ .el-breadcrumb__item:last-child {
  font-size: 20px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  height: 100px;
}

.tabs {
  height: 875px;
  margin-bottom: 20px;
  border: 1px solid #ccc;
}

.list-list {
  min-height: 50vh;

  .Purchase {
    border-bottom: 1px solid #dcdcdc;
    margin-top: 20px;
  }
}

.tab {
  margin-top: 20px;
  margin-left: 20px;

  .Purchase {
    width: 1200px;
    height: 200px;

    .img {
      float: left;

      img {
        width: 274px;
        height: 165px;
      }
    }

    .particulars {
      display: inline-block;
      margin-left: 20px;

      .expatiate {
        width: 391px;
        height: 52px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #000000;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        -o-text-overflow: ellipsis; /* for Opera */
        text-overflow: ellipsis;
        overflow: hidden;
      }

      .category {
        margin-top: 15px;

        span:nth-child(1) {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
        }
      }

      .period {
        position: relative;
        width: 700px;
        margin-top: 11px;
        margin-bottom: 15px;

        span:nth-child(1) {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #999999;
        }

        .btn {
          position: absolute;
          top: 45px;
          right: 0;
          width: 130px;
          background: #18949c;
          border-radius: 5px;
          font-size: 18px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
        }
      }
    }
  }
}

.btns {
  float: right;
  width: 130px;
  border: 1px solid #2aa9b5;
  border-radius: 5px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #2aa9b5;
}

.moeys {
  margin: 25px 0 16px 0;
  width: 63px;
  height: 19px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #eb2020;
}

.box {
  height: 124px;
  border-radius: 1px;
  line-height: 70px;
  border: 1px solid #ccc;
  margin-right: 20px;
  margin-bottom: 10px;

  img {
    position: relative;
    top: 25px;
    width: 39px;
    height: 35px;
    margin-left: 24px;
  }

  .span1 {
    line-height: 80px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    margin-left: 15px;
  }

  .classifier {
    position: relative;
    left: 80px;
    bottom: 40px;
  }

  .span2 {
    float: right;
    margin-right: 38px;
    width: 74px;
    height: 17px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2baab5;
  }
}

.mistakes {
  height: 124px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  margin-right: 20px;

  span {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ff0000;
    line-height: 124px;
    margin-left: 26px;
  }

  .el-button {
    background: #ffffff;
    border: 1px solid #bfbfbf;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-left: 32px;
  }
}

.course {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 30px;
  margin: 20px 0;
}

.list {
  height: 79px;
  border: 1px solid #e5e5e5;
  margin-right: 20px;
  margin-top: 20px;

  .exercise {
    background: #ffffff;
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;

    span {
      float: left;
      line-height: 79px;
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin: 0 20px;
    }

    i {
      float: right;
      line-height: 79px;
      margin: 0 20px;
    }
  }
}

.complaint-main {
  padding: 20px;
  color: #888888;
  .msg {
    font-size: 22px;
    margin-bottom: 15px;
    text-align: center;
    &:last-child {
      margin-bottom: 0;
    }
  }
}

.notice-footer {
  border-top: 1px solid #5B5C5B;
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 30px;
  height: 50px;
  > div {
    flex: 1;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
  }
  > span {
    width: 1px;
    height: 50px;
    background-color: #5B5C5B;
  }
}
</style>
